import {
  initialEstimatesState,
  initialSettings,
  projectReducer as projectCoreReducer,
} from '@octopus-do/octopus-project-core'
import { createReducer } from '@reduxjs/toolkit'
import { commentReadsReducer } from '@store/reducers/commentReads'
import {
  activityHistoryReducer,
  initialActivityHistoryState,
} from '@store/reducers/manager/activityHistory/reducers'
import {
  initialProjectMetaStore,
  projectMetaReducer,
} from '@store/reducers/manager/meta/reducers'
import {
  storage as storageReducer,
  storageState,
} from '@store/reducers/manager/storage'
import type { ProjectManager } from '@store/reducers/manager/types'
import {
  initialProjectUsersState,
  projectUsersReducer,
} from '@store/reducers/manager/users/reducers'
import { threadsReducer } from '@store/reducers/threads'
import commentsLegacyReducer from '@storeOld/reducers/comments'
import { combineReducers } from 'redux'

// @ts-expect-error
const wrapReducer = (reducers, globalReducer) => {
  // @ts-expect-error
  return (state, action) => {
    const globalState = globalReducer(state, action)
    return reducers(globalState, action)
  }
}

export const initialProjectManagerStore = {
  meta: initialProjectMetaStore,
  threads: [],
  project: {
    arrows: [],
    attachments: [],
    blocks: {},
    colors: [],
    estimates: initialEstimatesState,
    externalLinks: [],
    nodes: [],
    sections: [],
    settings: initialSettings,
    stickyNotes: [],
    symbols: [],
    tabs: [],
    tags: [],
    content: {},
  },
  comments: [],
  commentReads: {},
  storage: storageState,
  users: initialProjectUsersState,
  activityHistory: initialActivityHistoryState,
}

const managerReducer = createReducer<ProjectManager>(
  initialProjectManagerStore,
  (builder) => builder
)

export const projectManagerReducer = wrapReducer(
  combineReducers({
    meta: projectMetaReducer,
    project: projectCoreReducer,
    comments: commentsLegacyReducer,
    commentReads: commentReadsReducer,
    storage: storageReducer,
    users: projectUsersReducer,
    activityHistory: activityHistoryReducer,
    threads: threadsReducer,
  }),
  managerReducer
)
